import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

import { ROUTE_TYPE } from '../../Configuration'
import { Inquiry } from '../../assets/ts/data/inquiry/inquiry'
import { STATUS_CODE } from '../../assets/ts/data/inquiry/inquiry-status-metadata'
import { getTotalNumberOfDays } from '../../assets/ts/date-and-time/date-and-time'
import {
  defaultToEmptyString,
  formatStatusName,
  twoDigits,
} from '../../assets/ts/formatting/formatting'
import { decodeHTML, toShortDateString } from '../../assets/ts/general/general'
import { MetadataContext } from '../../store/metadata-context-provider'
import { SelectionContext } from '../../store/selection-context-provider'
import { INQUIRY_STATUS } from '../../utils/constants/global-constants'
import InputCheckbox from '../../utils/controls/input-checkbox'

type Props = {
  deleteItems?: (selectedItem: string) => Promise<void>
  inquiry: Inquiry
  title?: string
}

const CustomerDashboardInquiresTableRow = ({ deleteItems, inquiry, title }: Props) => {
  const selection = useContext(SelectionContext)
  const guid = inquiry.InquiryGUID ?? ''
  const { inquiryStatuses } = useContext(MetadataContext)

  return (
    <>
      <tr>
          <th className='checkbox'>
            <InputCheckbox
              formClassName='form-horizontal font-0'
              inputProps={{
                checked: selection.keyIsSelected(guid),
                id: guid,
                label: `checkbox-${inquiry.InquiryID}`,
                name: 'Input Check',
                type: 'checkbox',
              }}
              onChange={(e) => selection.handleSingleCheckboxChange(e, guid ?? '')}
            />
          </th>
        <th aria-label={`${inquiry.InquiryID}`} tabIndex={0}>
          <Link
            className='links'
            state={{ prevPath: '/' }}
            title={`${inquiry.InquiryID}`}
            to={
              inquiry.StatusCode === 'SAVED'
                ? `${ROUTE_TYPE}createinquiry/${guid}`
                : `${ROUTE_TYPE}detailview/${guid}`
            }
          >
            {defaultToEmptyString(inquiry.InquiryID)}
          </Link>
        </th>
        <td aria-label={inquiry['Section/MetadataValue']} tabIndex={0}>
          {defaultToEmptyString(inquiry['Section/MetadataValue'])}
        </td>
        <td aria-label={inquiry['Category/MetadataValue']} tabIndex={0}>
          {defaultToEmptyString(inquiry['Category/MetadataValue'])}
        </td>
        <td aria-label={inquiry['CurrentlyServicingBy']} tabIndex={0}>
          {defaultToEmptyString(inquiry['CurrentlyServicingBy'])}
        </td>
        <td aria-label={toShortDateString(inquiry.ItemCreated)} tabIndex={0}>
          {defaultToEmptyString(toShortDateString(inquiry.ItemCreated))}
        </td>
        <td aria-label={toShortDateString(inquiry.ItemModified)} tabIndex={0}>
          {defaultToEmptyString(toShortDateString(inquiry.ItemModified))}
        </td>
        <th
          aria-label={inquiry['Status/StatusDescription']}
          data-table-status={INQUIRY_STATUS[inquiry.StatusCode ?? '']?.colorCode}
          tabIndex={0}
        >
          {defaultToEmptyString(formatStatusName(inquiry['Status/StatusDescription']))}
        </th>
        <td
          aria-label={twoDigits(
            getTotalNumberOfDays('ALL INQUIRIES', false, inquiry, null, inquiryStatuses)
          )}
          tabIndex={0}
        >
          {defaultToEmptyString(twoDigits(getTotalNumberOfDays('ALL INQUIRIES', false, inquiry, null, inquiryStatuses)))}
        </td>
        {inquiry?.StatusCode === STATUS_CODE.SAVED && (
          <td aria-label='delete' tabIndex={0} title='delete'>
            <span
              className='icon-trashbin font-12 color-primary cursor'
              onClick={() => deleteItems(inquiry.InquiryGUID)}
            ></span>
          </td>
        )}
      </tr>
      <tr>
        <th colSpan={12}>
          <div className='d-flex align-items-center'>
            <Link
              className='links'
              state={{ prevPath: '/' }}
              title={decodeHTML(inquiry.Subject)}
              to={`${ROUTE_TYPE}detailview/${inquiry.InquiryGUID}`}
            >
              {defaultToEmptyString(decodeHTML(inquiry.Subject))}
            </Link>

            <div className='d-flex ms-auto'>
              {inquiry.CustomerActionRequired && (
                <span
                  className='icon-flag title-color52 font-15'
                  style={{ position: 'sticky' }}
                ></span>
              )}
            </div>
          </div>
        </th>
      </tr>
    </>
  )
}

export default CustomerDashboardInquiresTableRow
